import React, { useState } from "react";
import Textfield from "../textfield";
import Timepicker from "../timepicker";
import Select from "../select";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";
// import 'react-datepicker/dist/react-datepicker.css';

function CustomTextField({
	className,
	style,
	onChange,
	onValueChange,
	name,
	typeName = "",
	placeholder = "",
	parametername = "",
	behaviorParameter = "",
	minFractionDigits,
	value,
	disabled = false,
	readOnly,
}) {
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	return (
		<div className={` ${className}`}>
			{/*  w-[70%] */}
			<div className={`p-inputgroup flex `} style={style}>
				<InputNumber
					disabled={disabled}
					readOnly={readOnly}
					placeholder={placeholder}
					type={"int"}
					keyfilter={"int"}
					maxFractionDigits={2}
					min={0}
					maxLength={8}
					// max={100}
					value={value}
					behaviorParameter={behaviorParameter}
					minFractionDigits={minFractionDigits}
					className={`rounded-r-none `}
					pt={{
						root: {
							className: "border border-gray-200  h-10 cursor-not-allowed",
						},
					}}
					name={name}
					onValueChange={onValueChange}
				/>
				<span className="p-inputgroup-addon p-0 h-10 col-span-2">
					{/* <span className="text-black">{"coins"}</span> */}

					<div
						typeName={typeName}
						parametername={parametername}
						className="w-full px-2 text-black h-full flex justify-center items-center text-center border-none rounded-r-lg rounded-l-none bg-primary-primaryYellow"
					>
						{parametername}
					</div>
				</span>
			</div>
		</div>
	);
}

export default CustomTextField;
